import './HistoryView.css';
import { faBookmark, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { unselectHistoryAction } from '../../actions/proceedingActions';
import messages from '../../constants/messages';
import alertMessages from '../../helpers/alertMessages';
import api from '../../helpers/api';
import { getApiPrefix } from '../../helpers/authHelper';
import es from '../../lang/es';
import HistoryAttachment from './Actions/HistoryAttachment';
import HistoryLink from './Actions/HistoryLink';
import apiMethods from '../../constants/apiMethods';
import Signatures from './Signatures';

const HistoryView = ({ proceeding }) => {
    //Inicializo el dispatch
    const dispatch = useDispatch();

    const [ showSignatures, setShowSignatures ] = useState(false);

    //Tomo del store
    const selectedHistory = useSelector(state => state.proceeding.selectedHistory);
    //Manejo el click (prevención)
    const handleClick = e => {
        e.preventDefault();
        return false;
    }
    //Manejo la impresión
    const handlePrint = async () => {
        //Ejecuto
        try{
            //Armo los datos de la consulta
            const data = {
                jurisdiction: proceeding.jurisdiction_id,
                proceeding: proceeding.procid,
                history: selectedHistory.history.histid
            }
            //Muestro espera
            alertMessages.waiting(messages.LOADING.DOWNLOADING);
            //Consulta
            const response = await api.post(`${getApiPrefix()}${apiMethods.HISTORY_TEXT_DOWNLOAD}`, data);
            //Obtengo los datos
            const res = response.data;
            //Abro en nueva ventana la URL
            window.open(res.data);
            //Oculto la espera
            alertMessages.close();
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Cierro la espera
            alertMessages.close();
            //Mensaje de error
            alertMessages.error(data.message);
        }
    }
    //Manejo el cierre
    const handleClose = () => {
        //Llamo al dispatch
        dispatch( unselectHistoryAction() );
    }

    const handleCertificates = () => {
        setShowSignatures(!showSignatures);
    }
    //Render
    return (
        <Modal show={selectedHistory && true} onHide={handleClose} size="xl" scrollable={true} centered={true}>
            <Modal.Header className="bg-gray" closeButton={true}>
                <Modal.Title className="h5">
                    {
                        selectedHistory.history ? (
                            <React.Fragment>
                                <strong>{`${selectedHistory.history.fecha} | ${selectedHistory.history.dscr}`}</strong>
                                <br/>
                                <small>
                                    { `${proceeding.nro_expediente} | ${proceeding.acto} C/ ${proceeding.dema} S/ ${proceeding.tipo_proceso}` }
                                </small>
                                {
                                    selectedHistory.history.fechaDeposito ? (
                                        <React.Fragment>
                                            <br />
                                            <i>{ `Depositado en casillero virtual el: ${selectedHistory.history.fechaDeposito}` }</i>
                                        </React.Fragment>
                                     ) : null
                                }
                                {
                                    selectedHistory.history.firm ? (
                                        <>
                                        <br />
                                        <Button variant='success' size='sm' onClick={handleCertificates}>
                                            <FontAwesomeIcon icon={ faBookmark } /> <strong>{!showSignatures ? 'VER' : 'OCULTAR'} FIRMANTES</strong>
                                        </Button>
                                        </>
                                    ) : null
                                }
                            </React.Fragment>
                        ) : null
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 align-middle">
                        {
                            selectedHistory.history ? (
                                <React.Fragment>
                                    {
                                        selectedHistory.history.texto && selectedHistory.history.texto !== '' ? (
                                            <div dangerouslySetInnerHTML={{__html: selectedHistory.history.texto}} onClick={handleClick} />
                                        ) : (
                                            <div className="alert alert-info mt-3">
                                                <i>{ messages.ERROR.NO_TEXT }</i>
                                            </div>
                                        )
                                    }
                                    <div className="alert alert-warning">
                                        Actuación firmada en fecha: <strong>{ selectedHistory.history.fecha }</strong>
                                    </div>
                                    {
                                        selectedHistory.history.certificado ? (
                                            <div className="alert alert-success">
                                                {
                                                    selectedHistory.registry ? (
                                                        <React.Fragment>
                                                            <small>NRO. SENT.: { selectedHistory.registry.num1 } - FECHA SENT: { selectedHistory.registry.fec1 }</small>
                                                            <br/>
                                                        </React.Fragment>
                                                    ) : null
                                                }
                                                Certificado digital:
                                                <br/>
                                                <strong>{ selectedHistory.history.certificado.dscr }</strong>
                                            </div>
                                        ) : null
                                    }
                                    {
                                        selectedHistory.history.firmas && selectedHistory.history.firmas.length > 0 ? (
                                            selectedHistory.history.firmas.map(firma => (
                                                <div className="alert alert-success">
                                                    Certificado digital:
                                                    <br/>
                                                    <strong>{ firma.certificado.dscr }</strong>
                                                </div>
                                            ))
                                        ) : null
                                    }
                                </React.Fragment>
                                
                            ) : null
                        }
                    </div>
                </div>
            </Modal.Body>
            {
                showSignatures && selectedHistory.history ? (
                    <div className='signature-panel'>
                        <div className='alert alert-info'>
                            <div className='row'>
                                <div className='col-10 col-sm-11'>
                                    <h4 className='mb-0'>Firmantes</h4>
                                </div>
                                <div className='col-2 col-sm-1'>
                                    <Button variant='danger' size='sm' className='float-right' onClick={handleCertificates}>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <Signatures history={selectedHistory.history} show={showSignatures} />
                    </div>
                ) : null
            }
            <Modal.Footer className="bg-light">
                <div className="mr-auto">
                    <OverlayTrigger
                        key={`hv-${selectedHistory.history.histid}`}
                        placement="right"
                        overlay={
                            <Tooltip id={`tooltipHistPrint-${selectedHistory.history.histid}`}>
                                { es.PRINT.toUpperCase() }
                            </Tooltip>
                        }
                    >
                        <Button variant="primary" onClick={handlePrint}>
                            <FontAwesomeIcon icon={ faPrint } />
                        </Button>
                    </OverlayTrigger>
                    {
                        selectedHistory.history && selectedHistory.history.archivos && selectedHistory.history.archivos.length > 0 ? (
                            <HistoryAttachment
                                proceeding={proceeding}
                                history={selectedHistory}
                            />
                        ) : null
                    }
                    {
                        selectedHistory.history && selectedHistory.history.vinculos && selectedHistory.history.vinculos.length > 0 ? (
                            <HistoryLink
                                proceeding={proceeding}
                                history={selectedHistory}
                            />
                        ) : null
                    }
                </div>
                <Button variant="danger" onClick={handleClose}>
                    <FontAwesomeIcon icon={ faTimes } /> <strong>{ es.CLOSE.toUpperCase() }</strong>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HistoryView;